import React from 'react';
import PropTypes from 'prop-types';
import SchoolSearchWithLabelV2 from '../../../../components/composite/FormSets/SchoolSearchWithLabelV2/SchoolSearchWithLabelV2';
import { iamApiUrl, searchServiceUrl } from '../../../../destructured-front-end-config';
import { setFieldAndValidate } from '../../../../utils/field-utils';
import { userFieldSchemas } from '../../../../utils/validation-utils';

const SchoolSelectorSet = ({
  brand, school, setSchool, disabled = false,
}) => (
  <SchoolSearchWithLabelV2
    id="institution"
    label="Primary School or Institution"
    value={school.value?.institution}
    brand={brand}
    searchServiceUrl={searchServiceUrl}
    iamApiUrl={iamApiUrl}
    errorMsg={school.error}
    onChange={
        ({
          cAccount,
          institutionId,
          schoolName,
        }) => setFieldAndValidate(school, setSchool, { institution: schoolName, cAccount, institutionId }, userFieldSchemas.institution)
      }
    onSelect={
        ({
          cAccount,
          accountId,
          name,
          prettyName,
        }) => setFieldAndValidate(school, setSchool, { institution: prettyName || name, cAccount, institutionId: accountId }, userFieldSchemas.institution)
      }
    disabled={disabled}
  />
);

SchoolSelectorSet.propTypes = {
  brand: PropTypes.object.isRequired,
  school: PropTypes.object.isRequired,
  setSchool: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SchoolSelectorSet.defaultProps = {
  disabled: false,
};

export default SchoolSelectorSet;
